module.exports = __webpack_public_path__ + "img/minus.2155fd3.svg";